/**
 * Every call behind the login goes through here.
 *
 * It exists so that no screen ever touches the token store. A screen asks for notes; this module
 * makes sure a live access token is presented, refreshing first if the stored one is within a
 * minute of expiring. That is the API's own advice — refresh on `expires_in`, not on a 401 — and
 * following it means a slow request never dies of a token that expired while it was in flight.
 *
 * A personal access token is never used here. It cannot be: `/tokens`, `/auth/me`, `/account` and
 * `/onboarding` all refuse one by design, so that a credential sitting in an MCP client's
 * configuration file cannot mint more credentials or delete the account it was issued by. This app
 * holds a session; that is the credential it uses for everything.
 */

import { getFreshAccessToken } from "../auth/session";
import { request, type RequestOptions } from "./client";

export async function authed<T>(
  path: string,
  options: Omit<RequestOptions, "accessToken"> = {},
): Promise<T> {
  const accessToken = await getFreshAccessToken();
  return request<T>(path, { ...options, accessToken });
}
